import { create } from 'zustand';
import { EdgeData } from '../types';
import { MarkerType } from 'reactflow';

interface DefaultEdgeState {
  // Default edge properties
  defaultEdgeData: Partial<EdgeData>;
  defaultEdgeStyle: {
    stroke: string;
    strokeWidth: number;
  };
  defaultMarkerStart: MarkerType | undefined;
  defaultMarkerEnd: MarkerType | undefined;
  defaultAnimated: boolean;
  defaultType: string;
  
  // Function to update default edge properties
  setDefaultEdgeProperties: (
    edgeData: Partial<EdgeData>,
    edgeStyle: { stroke: string; strokeWidth: number },
    markerStart?: MarkerType | undefined,
    markerEnd?: MarkerType | undefined,
    animated?: boolean,
    type?: string
  ) => void;
}

// Create a store for default edge properties
const useDefaultEdgeStore = create<DefaultEdgeState>((set) => ({
  // Initial default values
  defaultEdgeData: {
    shape: 'default',
    color: '#6b7280', // Gray color (using Tailwind gray-500)
    thickness: 2,
    animated: false,
    markerStart: undefined,
    markerEnd: undefined,
    points: [],
  },
  defaultEdgeStyle: {
    stroke: '#6b7280', // Gray color
    strokeWidth: 2,
  },
  defaultMarkerStart: undefined,
  defaultMarkerEnd: undefined,
  defaultAnimated: false,
  defaultType: 'editable-edge',
  
  // Function to update default edge properties
  setDefaultEdgeProperties: (
    edgeData,
    edgeStyle,
    markerStart,
    markerEnd,
    animated = false,
    type = 'editable-edge'
  ) => {
    set({
      defaultEdgeData: { ...edgeData },
      defaultEdgeStyle: { ...edgeStyle },
      defaultMarkerStart: markerStart,
      defaultMarkerEnd: markerEnd,
      defaultAnimated: animated,
      defaultType: type,
    });
  },
}));

export default useDefaultEdgeStore;
